import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
function useCursor(hovered, onPointerOver = "pointer") {
  const canvas = useThree((s) => s.gl.domElement);
  useEffect(() => {
    if (hovered) {
      canvas.style.cursor = onPointerOver;
      return () => {
        canvas.style.cursor = "default";
      };
    }
  }, [hovered]);
}
export {
  useCursor
};
//# sourceMappingURL=index222.js.map
